import ReactGA from 'react-ga4';

export const sendToAnalytics = ({ id, name, value }) => {
  ReactGA.event({
    category: 'Web Vitals',
    action: name,
    value: Math.round(name === 'CLS' ? value * 1000 : value), // CLS values are small decimals, scale up for GA4 integers
    label: id,
    nonInteraction: true, // Mark event as non-interactive so it doesn't affect bounce rate
  });
};

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry); // INP is the current Core Web Vital ranking signal (replacing FID)
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
